// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".formulate-input-errors[data-v-412b5bc6]{color:red}.extra-area-name[data-v-412b5bc6]:hover{cursor:pointer}.cell-area .area-row-checkbox i[data-v-412b5bc6]{font-size:20px}.cell-area div.area-row-label[data-v-412b5bc6]{font-size:16px;cursor:pointer}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
